<template>
  <div class="container">
    <div class="list-header">
      <van-icon @click="$router.back(-1)" class="back-top-icon" name="arrow-left" />
      <div class="header-title">使用者详情</div>
      <div class="header-left">&nbsp;</div>
    </div>
    <div class="user-list">
      <div class="user-list-item">
        <div class="item-head">
          <div class="item-head-t">{{ item.userName }}</div>
          <div class="item-head-d">{{ $route.query.deviceName || '眼保仪' }}</div>
        </div>
        <div class="item-cell">
          <div class="item-cell-l">性别</div>
          <div class="item-cell-r item-cell-r-un">
            <van-radio-group v-model="item.sex" direction="horizontal">
              <van-radio checked-color="#2B67D9" :name="1">男</van-radio>
              <van-radio checked-color="#2B67D9" :name="2">女</van-radio>
            </van-radio-group>
          </div>
        </div>
        <div class="item-cell">
          <div class="item-cell-l">生日</div>
          <div @click="birthShow = true" class="item-cell-r item-cell-r-un">{{item.birthday || '未知'}}</div>
        </div>
        <div class="item-cell">
          <div class="item-cell-l">身高</div>
          <div @click="shenGaoShow = true" class="item-cell-r item-cell-r-un">{{item.height || '未知'}} cm</div>
        </div>
        <div class="item-cell">
          <div class="item-cell-l">体重</div>
          <div @click="tiZhongShow = true" class="item-cell-r item-cell-r-un">{{item.weight || '未知'}} kg</div>
        </div>
        <div class="item-cell">
          <div class="item-cell-l">是否佩戴眼镜</div>
          <div class="item-cell-r item-cell-r-un">
            <van-radio-group v-model="item.isGlasses" direction="horizontal">
              <van-radio checked-color="#2B67D9" :name="'1'">否</van-radio>
              <van-radio checked-color="#2B67D9" :name="'0'">是</van-radio>
            </van-radio-group>
          </div>
        </div>
        <div class="item-cell">
          <div class="item-cell-l">您与Ta的关系</div>
          <div @click="guanxShow = true" class="item-cell-r item-cell-r-un">
            {{ item.relationship == 1 ? '父母' : (item.relationship == 2 ? '其它' : '未知') }}<van-icon class="arrow-down" name="arrow-down" />
          </div>
        </div>
      </div>
    </div>
    <div @click="save()" class="save-btn"> 保存 </div>
    <!-- 更改生日 -->
    <van-popup position="bottom" v-model="birthShow">
      <van-datetime-picker
        @cancel="birthShow = false"
        @confirm="changeBirth"        
        :min-date="minDate"
        :max-date="maxDate"
        type="date"
        title="Ta的生日"
      />
    </van-popup>
    <!-- 更改关系 -->
    <van-popup position="bottom" title="您与Ta的关系" v-model="guanxShow">
      <van-picker
        show-toolbar
        :columns="guanxColumns"
        value-key="label"
        @cancel="guanxShow = false"
        @confirm="changeGuanx"
      />
    </van-popup>
    <!--更改体重 -->
    <van-popup position="bottom" title="您与Ta的关系" v-model="tiZhongShow">
      <van-picker
        show-toolbar
        :columns="tiZhongColumns"
        value-key="label"
        @cancel="tiZhongShow = false"
        @confirm="changeTiz"
      />
    </van-popup>
    <!--更改身高 -->
    <van-popup position="bottom" title="身高" v-model="shenGaoShow">
      <van-picker
        show-toolbar
        :columns="shenGaoColumns"
        value-key="label"
        @cancel="shenGaoShow = false"
        @confirm="changeShenG"
      />
    </van-popup>
  </div>
</template>

<script>
import { Icon, RadioGroup, Radio, DatetimePicker, Popup, Picker } from 'vant';
import { range, forEach, isArray } from 'lodash';
import moment from 'moment';
import { updateDeviceUser } from '@/api/h5'

const shenGaoColumns = [];
const tiZhongColumns = [];

forEach(range(25, 210), (i) => {  
  if(i >= 90) shenGaoColumns.push({value: i, label: `${i} cm`});
  if(i >= 25 && i <= 120) tiZhongColumns.push({value: i, label: `${i} kg`});
})
// console.log(tiZhongColumns, '----')

export default {
  components: {[Icon.name]: Icon, [RadioGroup.name]: RadioGroup, [Radio.name]: Radio, [DatetimePicker.name]: DatetimePicker, [Popup.name]: Popup, [Picker.name]: Picker},
  data() {
    return {
      item: {},
      currentDate: new Date(),
      birthShow: false,
      minDate: new Date('1990-01,01'),
      maxDate: new Date(),
      guanxShow: false,
      // 和用户的关系0未知，1父母，2其他
      guanxColumns:[{value: '1', label: '父母'}, {value: '2', label: '其它'}],
      shenGaoColumns,
      tiZhongColumns,
      tiZhongShow: false,
      shenGaoShow: false,
    }
  },
  created() {
    const item = JSON.parse(this.$route.query.item);
    item.birthday = isArray(item.birthday) ? item.birthday.join('-'): '';
    this.item = item
  },
  methods: {
    save() {
      console.log(this.item, 'form');      
      const params  = {
        ...this.item,
        createTime: undefined,
        birthday: moment(this.item.birthday).format('yyyy-MM-DD').split('-')
      }
      
      updateDeviceUser(params).then(res => {
        this.$toast('修改成功');
        this.$router.go(-2);
      })

    },
    changeBirth(v) {
      console.log(v, 'curenntDate');
      this.item.birthday = moment(v).format('yyyy-MM-DD');
      this.birthShow = false;
    },
    changeGuanx(v) {
      console.log(v, 'guanx')
      this.item.relationship = v.value;
      this.guanxShow = false;
    },
    changeTiz(v) {
      console.log(v, 'tz')
      this.item.weight = v.value;
      this.tiZhongShow = false;
    },
    changeShenG(v) {
      console.log(v, 'shenG')
      this.item.height = v.value;
      this.shenGaoShow = false;
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100vw;
  min-height: 100vh;
  background: #F6F8F9;
  .save-btn {
    margin: .4rem auto;
    width: 4.17rem;
    height: .77rem;
    background: #0074FE;
    border-radius: .12rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: .27rem;
    color: #FFFFFF;
    line-height: .77rem;    
    text-align: center;
    font-style: normal;
  }
  .item-cell {
    margin: 0 auto;
    width: 6.54rem;
    height: .39rem;
    padding: .38rem 0 .19rem;
    border-bottom: .02rem solid #EEE;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .arrow-down {
      font-size: .3rem;
    }
    .item-cell-l {
      font-size: .27rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
    .item-cell-r {
      font-size: .27rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #000000;
    }
    .item-cell-r-un {      
      color: #999999;
    }
  }
  .item-head {
    display: flex;
    padding: .3rem .3rem 0;
    justify-content: space-between;
    align-items: center;
    .item-head-t {    
      font-size: .31rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #000000;
    }
    .item-head-d {
      font-size: .27rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #999999;
    }
  }
  .user-list {
    padding: .85rem 0 .2rem;
    // min-height: 100vh;
    .user-list-item {
      margin: .2rem auto 0;
      width: 7.12rem;
      height: 7rem;
      background: #FFFFFF;
      box-shadow: 0 .04rem .21rem -.10rem rgba(0,0,0,0.1);
      border-radius: .08rem;
    }
  }
  .list-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 9;
    height: .85rem;
    padding: 0 .46rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #FFF;
    .back-top-icon {
      width: .3rem;
      font-size: .32rem;
      color: #000;
      font-weight: bolder;
    }
    .header-title {
      font-size: .31rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #000000;
    }
    .header-left {
      width: .3rem;
    }
  }
}
</style>